import React, { useState } from 'react';
import Offcanvas from "react-bootstrap/esm/Offcanvas";
import MobileMenuComponent from '../Menu/MobileMenuComponent';
import 'react-circular-progressbar/dist/styles.css';
import SiderParProgressbarComponent from '../SiderParProgressbarComponent';
import { useAppContext, UserAvatarProps } from '../../../AppContext';
function MobileHeaderComponent({items}:any,{...props }) {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function UserAvatar(props: UserAvatarProps) {
    return <img
        src={props.user.avatar || 'static/img/no-profile-picture.jpeg'} alt="Active Directory Photo" className={props.classname || ''}

    ></img>;
}
const app = useAppContext();
const user = app.user || { displayName: '', jobTitle: '' };

  return (
    <section className="header-mobile d-lg-none d-block">
        <div className="container-fluid">
          <div className="row g-0 text-center">
            <div className="col align-self-end">
              <div className="item01 item02">
                <a href="/" ><img src="/static/img/main-logo.png" alt="img" className="img-fluid" /></a>
              </div>
            </div>
            <div className="col  align-self-end">
              <div className="item01 item03">
                <a onClick={handleShow} href="#userSideBar" role="button" aria-controls="userSideBar"><img src="/static/img/mobile-menu.png" alt="img" className="img-fluid" /></a>
                <a href="#" className="normal-button">الخدمات</a>
              </div>
            </div>
            <div className="col  align-self-end">
              <div className="item01 item04">
                <img src="/static/img/logo2.png" alt="img" className="img-fluid" />
                <a target="_blank"  href="https://tatweertransit.walaplus.com">العروض</a>
              </div>
            </div>
            <div className="col  align-self-end">
              <div className="item01 item05">
                <img src="/static/img/logo1.png" alt="img" className="img-fluid" />
                <a target="_blank"  href="https://sahel.tatweertransit.com">الدخول لنظام سهل</a>
              </div>
            </div>
            <div className="col  align-self-end">
              <div className="item01 item06">
                <a className="dropdown-img" onClick={handleShow} href="#userSideBar" role="button" aria-controls="userSideBar"><img src="/static/img/dropdown.png" alt="img" className="img-fluid" /></a>
                <UserAvatar user={user} classname={"img-fluid"}  /> 
                <a href="#" className="normal-button2">خروج</a>
              </div>
            </div>
          </div>
        </div>
        <Offcanvas className="w-100 header-c-mobile" placement="end" show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
         
        </Offcanvas.Header>
        <Offcanvas.Body >
            {/* here code put */}
            <div className="row g-0">
              <div className="col-5">
                {/* nav-body start */}
                <MobileMenuComponent items={items}/>
                
                {/* nav-body end */}
              </div>
              <div className="col-7 pe-3">
                {/* single item start */}
                <div className="item-col-lg-25 w-100">
                  <div className="user">
                  <UserAvatar user={user} /> 
                    <div className="bar-box bar-box1">
                      <h4>{user['displayName']}</h4>
                    </div>
                    <div className="bar-box bar-box2">
                      <h6 className="mb-0">{user['jobTitle']}</h6>
                    </div>

                    <div className="bar-link">
                    <a href="/Calendar" >تقويم الاسبوع</a>
                    </div>

                    <br/>


                    <div className="bar-link">
                    <a href="#" onClick={app.signOut!}>خروج</a>
                    </div>
                  </div>
                  <div className="bar-progres-rounded text-center">
                    
                   {/*  <SiderParProgressbarComponent/>
                    <SiderParProgressbarComponent/> */}
                      

                  </div>
                </div>
                {/* single item end */}
              </div>
            </div>
          
        </Offcanvas.Body>
      </Offcanvas>
     
      </section>
  );
}

export default MobileHeaderComponent;


